import type { SystemClient } from '../@types/SystemClient';
import type { Actions } from '../actions';
import {
  REQUEST_FAILED as BOUND_REQ_FAILED,
  RCV_BOUND_SYSTEM_CLIENT_LIST,
  RCV_CREATE_BOUND_SYSTEM_CLIENT,
  RCV_REMOVE_BOUND_SYSTEM_CLIENT,
  REQ_BOUND_SYSTEM_CLIENT_LIST,
  REQ_CREATE_BOUND_SYSTEM_CLIENT,
  REQ_REMOVE_BOUND_SYSTEM_CLIENT,
} from '../actions/bound-system-clients';
import { REQ_BRANCH } from '../actions/branch';
import {
  RCV_CREATE_UNBOUND_SYSTEM_CLIENT,
  RCV_REMOVE_UNBOUND_SYSTEM_CLIENT,
  RCV_UNBOUND_SYSTEM_CLIENT_LIST,
  REQ_CREATE_UNBOUND_SYSTEM_CLIENT,
  REQ_REMOVE_UNBOUND_SYSTEM_CLIENT,
  REQ_UNBOUND_SYSTEM_CLIENT_LIST,
  REQUEST_FAILED as UNBOUND_REQ_FAILED,
} from '../actions/unbound-system-clients';
import { requestStatus, responseStatus } from '../shared/statuses';

interface SystemClientsState {
  requestStatus: number;
  responseStatus: number;
  bound: SystemClient[];
  unbound: SystemClient[];
}

const _initialState: SystemClientsState = {
  requestStatus: requestStatus.WAITING,
  responseStatus: responseStatus.OK,
  bound: [],
  unbound: [],
};

const systemclientsReducer = (
  state: SystemClientsState = _initialState,
  action: Actions,
): SystemClientsState => {
  let list = null;
  let index = -1;

  switch (action.type) {
    case REQ_BOUND_SYSTEM_CLIENT_LIST:
      return {
        ...state,
        requestStatus: requestStatus.FETCHING_LIST,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_BOUND_SYSTEM_CLIENT_LIST:
      return {
        ...state,
        bound: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_CREATE_BOUND_SYSTEM_CLIENT:
      return {
        ...state,
        requestStatus: requestStatus.CREATING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_CREATE_BOUND_SYSTEM_CLIENT:
      list = state.bound.slice();
      list.push(action.response);

      return {
        ...state,
        bound: list,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_REMOVE_BOUND_SYSTEM_CLIENT:
      return {
        ...state,
        requestStatus: requestStatus.REMOVING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_REMOVE_BOUND_SYSTEM_CLIENT:
      list = state.bound.slice();
      index = list.findIndex((sc) => sc.id === action.response.id);

      if (index >= 0) {
        list.splice(index, 1);
      }

      return {
        ...state,
        bound: list,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case BOUND_REQ_FAILED:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.FAILED,
      };
    case REQ_UNBOUND_SYSTEM_CLIENT_LIST:
      return {
        ...state,
        requestStatus: requestStatus.FETCHING_LIST,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_UNBOUND_SYSTEM_CLIENT_LIST:
      return {
        ...state,
        unbound: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_CREATE_UNBOUND_SYSTEM_CLIENT:
      return {
        ...state,
        requestStatus: requestStatus.CREATING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_CREATE_UNBOUND_SYSTEM_CLIENT:
      list = state.unbound.slice();
      list.push(action.response);

      return {
        ...state,
        unbound: list,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_REMOVE_UNBOUND_SYSTEM_CLIENT:
      return {
        ...state,
        requestStatus: requestStatus.REMOVING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_REMOVE_UNBOUND_SYSTEM_CLIENT:
      list = state.unbound.slice();
      index = list.findIndex((sc) => sc.id === action.response.id);

      if (index >= 0) {
        list.splice(index, 1);
      }

      return {
        ...state,
        unbound: list,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case UNBOUND_REQ_FAILED:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.FAILED,
      };
    case REQ_BRANCH:
      return { ...state, bound: [] };
    default:
      return state;
  }
};

export default systemclientsReducer;
